import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceConfigService } from '@app/services/service-config.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators'
import { prefixWith } from '@app/helpers/services.helpers';
import { isNilOrEmpty } from 'ramda-adjunct';
import { ApplicationNumber } from '@app/models/app.model';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  constructor(private http: HttpClient, private serverConfig: ServiceConfigService) { }
  apiContext = `easy-app/api`;
  hideRenew = new BehaviorSubject<boolean>(false);
  enableChangeReport = new BehaviorSubject<boolean>(false);
  hideRenew$ = this.hideRenew.asObservable();
  searchResults = new BehaviorSubject<any>({});
  searchResults$ = this.searchResults.asObservable();
  disableChangeReport = new BehaviorSubject<boolean>(false);
  disableChangeReport$ = this.disableChangeReport.asObservable();
  getKbData = new BehaviorSubject<boolean>(false);
  getKbData$ = this.getKbData.asObservable();
  emailId$ = new BehaviorSubject<string>("");
  isReportChangedModalOpenedForFirstTime = false;
  showHideQFR = new BehaviorSubject<boolean>(false);
  showHideQFR$ = this.showHideQFR.asObservable();
  enableAppealOrHealthPlan = new BehaviorSubject<boolean>(false);
  showHideMyAppeals = new BehaviorSubject<boolean>(false);
  fromMyAppeals = new BehaviorSubject<boolean>(JSON.parse(sessionStorage.getItem('myAppealsUploadProof')));
  step1Info = new BehaviorSubject<boolean>(null);
  step1Information$ = this.step1Info.asObservable();
  step2Info = new BehaviorSubject<boolean>(null);
  step2Information$ = this.step2Info.asObservable();
  step3Info = new BehaviorSubject<boolean>(null);
  step3Information$ = this.step3Info.asObservable();
  step4Info = new BehaviorSubject<boolean>(null);
  step4Information$ = this.step4Info.asObservable();
  fomMobileApp = new BehaviorSubject<boolean>(false);
  fomMobileApp$ = this.fomMobileApp.asObservable();
  isHoh = new BehaviorSubject<boolean>(false);
  isHoh$ = this.isHoh.asObservable();
  reconDate = new BehaviorSubject<boolean>(false);
  reconDate$ = this.reconDate.asObservable();
  isCaseTerminated = new BehaviorSubject<boolean>(false);
  isCaseTerminated$ = this.reconDate.asObservable();
  dcsOrSSIMultipleCase = new BehaviorSubject<boolean>(false) 
  dcsOrSSIMultipleCase$ = this.dcsOrSSIMultipleCase.asObservable();
  isCaseDenied = new BehaviorSubject<boolean>(false);
  isCaseDenied$ = this.reconDate.asObservable();
  showDDABannerMessage$ = new BehaviorSubject<boolean>(false);
  isLinkDisable = new BehaviorSubject<boolean>(false);
  isLinkDisable$ = this.isLinkDisable.asObservable();
  counter;
  private cmbDataLoaded = false;

  saveCmbDataToSession(cmbData: any): void {
    sessionStorage.setItem('cmbNavigationData', JSON.stringify(cmbData));
    this.cmbDataLoaded = true;
  }

  getCmbDataFromSession(): any {
    const data = sessionStorage.getItem('cmbNavigationData');
    return data ? JSON.parse(data) : null;
  }

  clearCmbDataFromSession(): void {
    sessionStorage.removeItem('cmbNavigationData');
    this.cmbDataLoaded = false;
  }

  restoreBehaviorSubjectsFromSession(): void {
    const cmbData = this.getCmbDataFromSession();
    if (!cmbData) return;
    // Only restore if CMB data hasn't been loaded yet in this session
    // This prevents overwriting live data during normal navigation
    if (this.cmbDataLoaded) return;

    const subjectMap = {
      hideRenew: this.hideRenew,
      enableChangeReport: this.enableChangeReport,
      disableChangeReport: this.disableChangeReport,
      getKbData: this.getKbData,
      showHideQFR: this.showHideQFR,
      enableAppealOrHealthPlan: this.enableAppealOrHealthPlan,
      showHideMyAppeals: this.showHideMyAppeals,
      isHoh: this.isHoh,
      reconDate: this.reconDate,
      isCaseTerminated: this.isCaseTerminated,
      dcsOrSSIMultipleCase: this.dcsOrSSIMultipleCase,
      isCaseDenied: this.isCaseDenied
    };

    Object.keys(subjectMap).forEach(key => {
      if (cmbData[key] !== undefined) {
        subjectMap[key].next(cmbData[key]);
      }
    });
    this.cmbDataLoaded = true;
  }

  sendStep1Info(bool) {
    this.step1Info.next(bool);
  }

  getTerminateCaseStatus(bool) {
    this.isCaseTerminated.next(bool);
  }

  getDeniedCaseStatus(bool){
    this.isCaseDenied.next(bool);
  }

  sendStep2Info(bool) {
    this.step2Info.next(bool);
  }

  sendStep3Info(bool) {
    this.step3Info.next(bool);
  }
  sendStep4Info(bool) {
    this.step4Info.next(bool);
  }

  hideRenewal(bool) {
    this.hideRenew.next(bool);
  }

  fromMobileApptoTcc(bool) {
    this.fomMobileApp.next(bool)
  }

  disableRmc(value) {
    if (value === 'Y') {
      this.disableChangeReport.next(false);
    } else if (value === 'N') {
      this.disableChangeReport.next(true);
    }
  }

  isHeadofHousehold(bool) {
    this.isHoh.next(bool)
  }

  isDCSorSSIMultipleCase(bool){
    this.dcsOrSSIMultipleCase.next(bool);
  }

  getReconDate(bool) {
    this.reconDate.next(bool)
  }

  getKtBucketData(bool) {
    this.getKbData.next(bool)
  }

  gatewayURL() {
    return this.serverConfig.getServerConfig()['gatewayURL'];
  }

  getDocumentsWeNeed(indiv, pageId) {
    const viewTcc = sessionStorage.getItem('ViewTCC') === 'true' ? true : false;
    const isFinReassessment = JSON.parse(sessionStorage.getItem('isReassessment'));
    const wpAppNum = sessionStorage.getItem('wpAppNum');
    if (sessionStorage.uploadDoc && sessionStorage.userType === 'RP' && !viewTcc && !isFinReassessment) {
      indiv = null;
      sessionStorage.uploadDoc = '';
    }
    if(wpAppNum && (indiv === "null" || indiv === null)){ 
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/docsWeNeed/indv/${indiv}?tNumber=${wpAppNum}`, {headers: new HttpHeaders({'pageId': pageId, 'sessionId': this.getSessionId()})})
    } else {
      return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/docsWeNeed/indv/${indiv}`, {headers: new HttpHeaders({'pageId': pageId, 'sessionId': this.getSessionId()})})
    }
  }

  getCookie(name) {
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split("=");
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  getBenefitDashboard(indivId) {
    if(localStorage.getItem('chatbot') !== 'true') {
    const currentTime = Date.now(); // Get current timestamp in milliseconds
    localStorage.setItem('ulgTimestamp', currentTime.toString()); // Store as a string
    }
    const tcamKey = this.serverConfig.getServerConfig().TCAM_KEY;
    const sessionId = isNilOrEmpty(this.getCookie(tcamKey)) ? sessionStorage.getItem('tcam') : this.getCookie(tcamKey);
    const realTime = sessionStorage.getItem('realtimeIndvId') && sessionStorage.getItem('realtimeIndvId') !== 'null'&& sessionStorage.getItem('realtimeIndvId') !== '0' ? true : false
    if (!sessionStorage.getItem('counter') && realTime){
        sessionStorage.setItem('counter', '0');
    }
    if(sessionStorage.getItem('counter')){
      this.counter = Number (sessionStorage.getItem('counter'))
    }
    return realTime ? this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/cmbSumm/indv/${indivId}?cmbRealTime=true&cmbCounter=${this.counter}`, { headers: new HttpHeaders({ 'pageId': 'TCCMB', 'sessionId': sessionId }) })
    .pipe(tap(()=> { this.counter++; sessionStorage.setItem('counter', this.counter.toString())})): this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/cmbSumm/indv/${indivId}`, { headers: new HttpHeaders({ 'pageId': 'TCCMB', 'sessionId': sessionId }) })
  }

  getPerlsLtssData(payLoad){
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/ltssProgram`, payLoad, {headers: new HttpHeaders({'pageId': 'TCLTP', 'sessionId': this.getSessionId()})})
  }

  getLetters(indivNumber, type, begDate?, endDate?) {
    const contentHeaders = new HttpHeaders({'pageId': 'TCMLR', 'sessionId': this.getSessionId()});
    if (begDate && endDate) {
        const bdate = new Date(begDate).toISOString().split('T')[0];
        const edate = new Date(endDate).toISOString().split('T')[0];
        return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/viewMyLetters/indv/${indivNumber}?letterType=${type}&begDate=${bdate}&endDate=${edate}`, {headers : contentHeaders})
    }
    if (begDate) {
        const bdate = new Date(begDate).toISOString().split('T')[0];
        return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/viewMyLetters/indv/${indivNumber}?letterType=${type}&begDate=${bdate}`, {headers : contentHeaders})
    }
    if (endDate) {
        const edate = new Date(endDate).toISOString().split('T')[0];
        return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/viewMyLetters/indv/${indivNumber}?letterType=${type}&endDate=${edate}`, {headers : contentHeaders})
    }
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/viewMyLetters/indv/${indivNumber}?letterType=${type}`, {headers : contentHeaders})
  }

  getLTSSLetters(payload) {
    const contentHeaders = new HttpHeaders({'pageId': 'TCELR', 'sessionId': this.getSessionId()});
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/ltssLetters`, payload, {headers : contentHeaders})
  }

  getCommunicationPreferenceData(indiv) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCMP', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/users/getCommPreferences?indvId=${indiv}`, {headers : contentHeaders})
  }

  postCommunicationPreferenceData(data) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCMP', 'sessionId': this.getSessionId()});
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/users/updateCommPreferences`, data, {headers : contentHeaders})
  }

  getCaseDocuments(indivNumber) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCCD', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/checkmybenefits/cmbDocSumm/indv/${indivNumber}`, {headers: contentHeaders});
  }

  getUploadedDocuments(indivId, entityId?:string) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCUD', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/checkmybenefits/uploadeddocs${prefixWith('/', indivId)}${prefixWith('?entityId=', entityId)}`, {headers: contentHeaders});
  }

  getPrintPdf(applicationNumber, pageId = '') {
    const contentHeader = new HttpHeaders({'pageId': pageId, 'sessionId': this.getSessionId()})
    const wpSwitch = sessionStorage.getItem('isKepro') === 'true' ? '&userType=kepro' : "";
    const appType = sessionStorage.getItem('appType');
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewpdf?applicationNumber=${applicationNumber}&applicationModeCode=N${wpSwitch}&appType=${appType}`, {
        'responseType': 'arraybuffer' as 'json',
        headers : contentHeader
    });
  }

  getAppealPrintPdf(applicationNumber, pageId = '', currentLang, item, appealsPrint) {
    currentLang = currentLang === "en" ? "EN" : "ES";
    if(item?.submissionType?.code=="VFD")
    {
      currentLang = "EN";
    }
    const contentHeader = new HttpHeaders({'pageId': pageId, 'sessionId': this.getSessionId()})
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewpdf?applicationNumber=${applicationNumber}&applicationModeCode=N&lang${prefixWith('=', currentLang)}&indivId=${item?.indivId}&from=${appealsPrint}&SubmissionType=${item?.submissionType?.code}&AppealTypeSeqNum=${item?.aplSeqNum}`, {
        'responseType': 'arraybuffer' as 'json',
        headers : contentHeader
    });
  }

  getMedicalAppealPrintPdf(applicationNumber: ApplicationNumber, pageId: string, medicalApealpdf: string) {
    const contentHeader = new HttpHeaders({ 'pageId': pageId, 'sessionId': this.getSessionId() })
    const wpSwitch = sessionStorage.getItem('isKepro') === 'true' ? '&userType=kepro' : "";
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewpdf?applicationNumber=${applicationNumber}&applicationModeCode=N${wpSwitch}&from=${medicalApealpdf}`, {
      'responseType': 'arraybuffer' as 'json',
      headers: contentHeader
    });
  }

  getPrintDocPdf(payLoad) {
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewNotice`, payLoad, {
      'responseType': 'blob'
    });
  }

  getPrintLTSSDocPdf(payLoad) {
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/ltssLetters/view`, payLoad, {
      'responseType': 'blob'
    });
  }

  getPrintDoc(docId, pageId) {
    const contentHeaders = new HttpHeaders({'pageId' : pageId, 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewpdf?uploadDocId=${docId}`, {
        'responseType': 'arraybuffer' as 'json',
        headers: contentHeaders
    });
  }

  getPrintDocPP(appNum, lang) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCSS', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/viewpdf?applicationNumber=${appNum}&lang=${lang}`, {
        'responseType': 'arraybuffer' as 'json',
        headers: contentHeaders
    });
  }

  getEndCoverage(appNum) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCPEND', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/users/endMyCoverageDetails?appNum=${appNum}`, {headers: contentHeaders});
  }

  postEndCoverage(data) {
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/users/endMyCoverage`, { data });
  }

  postTutorial(data) {
    return this.http.post(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/publ/users/tutorial`, data, {headers: new HttpHeaders({'pageId': 'TCCDB', 'sessionId': this.getSessionId()})} )
  }
/* Function Not called  */
  getTccAppData(url, data) {
    return this.http.post(`${this.gatewayURL()}${this.apiContext}${url}`, data)
  }

  getUploadedDocsByTNum(tNum) {
    const contentHeaders = new HttpHeaders({'pageId' : 'TCCUD', 'sessionId': this.getSessionId()});
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}rest/api/indi/checkmybenefits/uploadeddocsByTNumber/${tNum}`, {headers: contentHeaders});
  }

  getSearchDetails(details) {
    this.searchResults.next(details);
  }


  getEmailId(): Observable<string> {
    return this.emailId$;
  }

  setEmailId(emailId: string): void {
    this.emailId$.next(emailId);
  }

  getSessionId(): string {
    const tcamKey = this.serverConfig.getServerConfig().TCAM_KEY;
    const sessionId = isNilOrEmpty(this.getCookie(tcamKey)) ? sessionStorage.getItem('tcam') : this.getCookie(tcamKey);
    return sessionId ?? '';
  }
  
  getVADTileFalg() : boolean {
    const displayVADTile = this.serverConfig.getServerConfig().displayVADTile
    return displayVADTile;
  }

  findSpTransalation(enVal: string) {
    const map = new Map<string, string>();
     map.set("ABLE account with", "Cuenta ABLE con");
    map.set("Annuity with", "Anualidades con");
    map.set("Bonds with", "Bonos con");
    map.set("Cash Support with", "Dinero en Efectivo con");
    map.set("Certificate of Deposit with", "Certificado de Depósito con");
    map.set("Checking Account with", "Cuenta de Cheques con");
    map.set("Dividends with", "Dividendos con");
    map.set("Health Reimbursement Account with", "Cuenta de Reembolso de Castos Médicos con");
    map.set("Individual Development Account with", "Cuenta de Desarrollo Individual con");
    map.set("Individual Retirement Account with", "Cuenta de Jubilación Individual con");
    map.set("Keogh Account with", "Cuenta de Keogh con");
    map.set("Loan with", "Préstamo con");
    map.set("Patient/Resident Trust Account with", "Cuenta Fiduciaria de Paciente/Residente con");
    map.set("Pension Fund with", "Pensiones con");
    map.set("Promissory Note with", "pagaré con");
    map.set("Qualified Tuition Savings (529 Plans) with", "Ahorros de Matrícula Calificados (529 Planes) con");
    map.set("Retirement Account with", "Cuenta de Jubilación con");
    map.set("Savings Account with", "Cuenta de Ahorros con");
    map.set("Stocks, Mutual Funds with", "Acciones, Fondos Mutuos con");
    map.set("Trust Fund with", "Fondo Fiduciario con");
    map.set("Farming/Fishing with", "Agricultura/Pesca con");
    map.set("Rental or Lease with", "Alquiler or Arrendamiento con");
    map.set("Alimony with", "Pensión Alimenticia con");
    map.set("Child Support Income with", "Ingresos de Manutención de Los Hijos con");
    map.set("Pension with", "Pensión con");
    map.set("Sick/Disability Pay with", "Pago por Enfermedad/Discapacidad con");
    map.set("Social Security with", "Seguridad Social con");
    map.set("SSI (Supplemental Security Income) with", "SSI (Seguridad de Ingreso Suplementario) con");
    map.set("Tribal Income with", "Ingresos Tribales con");
    map.set("Unemployment Insurance with", "Seguro de Desempleo con");
    map.set("Veterans Benefit with", "Beneficios para Veteranos con");
    map.set("Workers Compensation with", "Compensación de Trabajadores con");
    map.set("ABLE account", "Cuenta ABLE");
    map.set("Annuity", "Anualidades");
    map.set("Bonds", "Bonos");
    map.set("Cash Support", "Dinero en Efectivo");
    map.set("Certificate of Deposit", "Certificado de Depósito");
    map.set("Checking Account", "Cuenta de Cheques");
    map.set("Dividends", "Dividendos");
    map.set("Health Reimbursement Account", "Cuenta de Reembolso de Castos Médicos");
    map.set("Individual Development Account", "Cuenta de Desarrollo Individual");
    map.set("Individual Retirement Account", "Cuenta de Jubilación Individual");
    map.set("Keogh Account", "Cuenta de Keogh");
    map.set("Loan", "Préstamo");
    map.set("Patient/Resident Trust Account", "Cuenta Fiduciaria de Paciente/Residente");
    map.set("Pension Fund", "Pensiones");
    map.set("Promissory Note", "pagaré");
    map.set("Qualified Tuition Savings (529 Plans)", "Ahorros de Matrícula Calificados (529 Planes)");
    map.set("Retirement Account", "Cuenta de Jubilación");
    map.set("Savings Account", "Cuenta de Ahorros");
    map.set("Stocks, Mutual Funds", "Acciones, Fondos Mutuos");
    map.set("Trust Fund", "Fondo Fiduciario");
    map.set("Farming/Fishing", "Agricultura/Pesca");
    map.set("Rental or Lease", "Alquiler or Arrendamiento");
    map.set("Alimony", "Pensión Alimenticia");
    map.set("Child Support Income", "Ingresos de Manutención de Los Hijos");
    map.set("Pension", "Pensión");
    map.set("Sick/Disability Pay", "Pago por Enfermedad/Discapacidad");
    map.set("Social Security", "Seguridad Social");
    map.set("SSI (Supplemental Security Income)", "SSI (Seguridad de Ingreso Suplementario)");
    map.set("Tribal Income", "Ingresos Tribales");
    map.set("Unemployment Insurance", "Seguro de Desempleo");
    map.set("Veterans Benefit", "Beneficios para Veteranos");
    map.set("Workers Compensation", "Compensación de Trabajadores");
    for (const [key, value] of map.entries()) {
      const regex = new RegExp(key, "i");
      if (regex.test(enVal)) {
        return enVal.replace(regex, value);
      }
    }
    return enVal;
  }

}